<template>
  <div>
    <page-header
      :actions="[
        {
          text: 'Guardar',
          icon: 'fas fa-save',
          variant: 'success',
          click:
            this.model.amendmentFlag == '1' ? this.UpdateAmendment : this.save,
          visible: this.enableSaveButton,
        },
        {
          text: 'Imprimir',
          icon: 'fas fa-file',
          variant: 'outline-success',
          click: this.printContractAmendment,
          visible: this.canPrint,
        },
        {
          text: 'Firmar Enmienda',
          icon: 'fas fa-pen-alt',
          variant: 'success',
          click: this.signContract,
          visible: this.canSign,
        },
      ]"
      :on-return="() => $router.go(-1)"
      :page="page"
    />

    <board class="mb-2" :details="boardData" />

    <div class="c-tabs">
      <b-tabs
        content-class="mt-4"
        nav-class="custom-nav-container"
        :no-nav-style="true"
      >
        <b-tab active title="Información de Enmienda">
          <div>
            <validation-observer v-if="isLoaded" ref="formValidator">
              <information
                v-model="model.information"
                :is-read-only="isReadOnly"
              />
              <validity-information
                v-if="model.information.amendmentTypeDateFlag"
                key="validity-amendment"
                ref="validityInformation"
                v-model="model.validity"
                :can-edit-vigency="canEditAmendmentVigency"
                :is-read-only="isReadOnly"
                @save-vigency="onSaveVigency"
              />
              <amendment-document
                v-if="model.amendmentFlag"
                ref="amendmentDocument"
              />
            </validation-observer>
            <separation-of-funds
              v-if="model.information.amendmentTypeBalanceFlag"
              ref="FundSeparation"
              :bus="bus"
              :can-edit-balance="model.information.amendmentTypeBalanceFlag"
              :contract-id="model.id"
              :fiscal-year-description="model.validity.fiscalYearDescription"
              :is-amendment="
                model.amendmentFlag ||
                  model.information.amendmentTypeBalanceFlag
              "
              :is-contract-signed="model.isSignedFlag"
            />
            <SIFDEInformation
              v-if="showSections"
              :academic-year="academicYear"
              class="mt-5"
              :contract-number="contractNumberFinancialSystem"
            />
            <div
              v-show="canShowContractServices(model.information)"
              class="mt-5"
            >
              <service-information-list
                :add-enabled="
                  userHasPermissions('provider.contract.services.add')
                "
                :contract-id="contractId"
                :delete-enabled="
                  !isReadOnly &&
                    userHasPermissions('provider.contract.services.delete')
                "
                :edit-enabled="canEditService"
                :on-deleting="onServiceDeleting"
                :on-saving="onServiceSaving"
              />
            </div>
          </div>
        </b-tab>
        <b-tab
          v-if="proposalRequestId != null"
          title="Documentos de Contratación"
        >
          <contrat-tab
            :auto-remove-document="true"
            :is-amendment="true"
            :proposal-request-id="Number(proposalRequestId)"
          />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Information from './Information';
import ValidityInformation from './ValidityInformation';
import ServiceInformationList from '@/views/provider/management/contract/components/ServiceInformationList.vue';
import AmendmentDocument from './AmendmentDocument.vue';
import SIFDEInformation from '@/views/provider/management/contract/components/SIFDE/SIFDEInformation';
import SeparationOfFunds from '@/views/provider/proposalHistory/tabs/SeparationOfFundsTabV2.vue';
import ContratTab from '@/views/provider/proposalHistory/tabs/ContractTab.vue';
import {
  getProviderDetail as _getProviderDetail,
  getPurchaseOrderList as _getPurchaseOrderList,
  getAmendments as _getAmendments,
  insertContractAmendment as _insertContractAmendment,
  updateContractAmendment as _updateContractAmendment,
  signContract as _signContract,
  createContractService as _createContractService,
  editContractService as _editContractService,
  deleteContractService as _deleteContractService,
  updateContractVigency as _updateContractVigency,
} from '@/modules/provider/api';
import { getAcademicYear as _getAcademicYear } from '@/modules/shared/academicyear.api';
import { getContractDocument } from '@/modules/serviceProposalHistory/api';
import Vue, { nextTick } from 'vue';

import moment from 'moment';
import alert from '@/mixins/alert.mixin';
import _generalApi from '@/modules/app/api';

export default {
  name: 'MasterAmendment',
  components: {
    Information,
    ValidityInformation,
    ServiceInformationList,
    AmendmentDocument,
    SeparationOfFunds,
    SIFDEInformation,
    ContratTab,
  },
  mixins: [alert],
  data() {
    return {
      bus: new Vue(),
      board: {},
      detailsInfoTabs: {
        amendmentInfo: 0,
        DocumentosPropuesta: 1,
      },
      page: {
        title: 'Enmienda',
        icon: 'fas fa-user-tie',
        routes: ['Contrato'],
      },
      isReadOnly: false,
      reactive: {
        purchaseOrderList: [],
        isFormDirty: false,
      },
      model: {
        information: {
          amendmentTypeBalanceFlag: false,
          amendmentTypeDateFlag: false,
          amendmentTypeOtherFlag: false,
          contractNumberBase: '',
          contractNumberAdded: '',
          originalContractNumber: '',
          amendmentReason: '',
          contractNumberFinancialSystem: '',
        },
        validity: {
          fiscalYearDescription: null,
          effectiveFromDate: null,
          effectiveToDate: null,
          orig_EffecteFromDate: null,
          orig_EffectiveToDate: null,
        },
        proposalRequestId: null,
        purchaseOrderNumbers: [],
        id: null,
        isSignedFlag: false,
        isAmendment: false,
      },
      enableSignButton: false,
      enableSaveButton: true,
      services: [],
      isLoaded: null,
      academicYear: null,
    };
  },
  computed: {
    contractId() {
      return parseInt(this.$route.params.contractId);
    },
    params() {
      return this.$route.params;
    },
    boardData() {
      return [
        [
          {
            label: 'Nombre del Proveedor:',
            icon: 'fas fa-address-book',
            data: this.board.companyName,
            cols: 'col-md-6 col-sm-12',
          },
          {
            label: 'Tipo de Proveedor:',
            icon: 'fas fa-address-book',
            data: this.board.companyTypeName,
          },
          {
            label: 'Número Patronal:',
            icon: 'fas fa-ballot-check',
            data: this.board.ssn,
          },
        ],
      ];
    },
    subTotal() {
      let sum = 0;
      let sumTotal = 0;

      (this.model.purchaseOrderNumbers || []).forEach((item) => {
        sum += Number(item.amount || 0);
        sumTotal += Number(item.amount || 0);

        (item.purchases || []).forEach((child) => {
          sumTotal += Number(child.amount);
          if (!child.isOriginal) sum += Number(child.amount);
        });
      });
      return {
        added: sum,
        total: sumTotal,
      };
    },
    canEditService() {
      return (
        (!this.IsReadOnly &&
          this.userHasPermissions('provider.contract.services.edit')) ||
        (this.model.isSignedFlag &&
          this.userHasPermissions('provider.contract.services.edit.signed'))
      );
    },
    canShowContractServices() {
      return (vm) => vm.amendmentTypeDateFlag || vm.amendmentTypeBalanceFlag;
    },
    contractNumber() {
      return this.model.information.originalContractNumber;
    },
    contractNumberFinancialSystem() {
      return this.model.information.contractNumberFinancialSystem;
    },
    showSections() {
      return (
        (!this.enableSaveButton && !this.enableSignButton) ||
        (this.enableSaveButton && this.enableSignButton)
      );
    },
    proposalRequestId() {
      return this.model.proposalRequestId ?? null;
    },
    canPrint() {
      return this.userHasPermissions('provider.contract.amendment.print');
    },
    canSign() {
      return (
        this.enableSignButton &&
        this.userHasPermissions('provider.contract.amendment.sign')
      );
    },
    canEditAmendmentVigency() {
      return (
        this.model.information.amendmentTypeDateFlag &&
        this.userHasPermissions('provider.contract.vigency.edit')
      );
    },
  },
  provide() {
    return {
      injection: this.reactive,
    };
  },
  async mounted() {
    await this.loadProviderInformation();
    await this.getAcademicYears();
    await this.getAmendments();
  },
  methods: {
    async onSaveVigency(draft) {
      if (!draft.effectiveFromDate || !draft.effectiveToDate) {
        this.ShowToast(
          'Error',
          'Fecha de comienzo y finalización son requeridas.',
          'error'
        );
        return;
      }

      if (
        moment(draft.effectiveFromDate).isAfter(moment(draft.effectiveToDate))
      ) {
        this.ShowToast(
          'Error',
          'La fecha de comienzo no puede ser mayor a la fecha de finalización.',
          'error'
        );
        return;
      }

      try {
        await _updateContractVigency(
          this.contractId,
          draft.effectiveFromDate,
          draft.effectiveToDate
        );
        this.model.validity.effectiveFromDate = draft.effectiveFromDate;
        this.model.validity.effectiveToDate = draft.effectiveToDate;
        this.$refs.validityInformation.finishEditing();

        this.ShowToast(
          'Proceso Exitoso',
          'La vigencia fue guardada exitosamente.',
          'success'
        );
      } catch (error) {
        this.ShowToast(
          'Error',
          error?.response?.data?.message ||
            'Ocurrió un error al guardar los datos.',
          'error'
        );
      }
    },
    async printContractAmendment() {
      try {
        await _generalApi.getContractProviderReport(this.contractId);
        this.enableSignButton = true;
      } catch (err) {
        let message =
          err?.response?.data?.message ?? 'Error al descaragr el documento';
        this.ShowToast('', message, 'error');
      }
    },
    onActiveTab(indexTab) {
      this.currentIndexTab = Number(indexTab);
    },
    async loadProviderInformation() {
      await _getProviderDetail(this.params.companyId)
        .then((response) => {
          this.board = response.data;
        })
        .catch(() => {
          this.ShowToast(
            'Error',
            'Ocurrió un error cargando los datos',
            'error'
          );
        });
    },
    async getAmendments() {
      await _getAmendments({ ...this.params }).then(async ({ data }) => {
        this.model = {
          ...this.model,
          proposalRequestId: data.proposalRequestId,
          amendmentFlag: data.amendmentFlag == '1',
          information: {
            ...this.model.information,
            amendmentTypeBalanceFlag: data.amendementTypeBalanceFlag == '1',
            amendmentTypeDateFlag: data.amendementTypeDateFlag == '1',
            contractNumberBase: data.contractNumber || '',
            contractNumberAdded:
              data.amendmentFlag !== '1'
                ? '-' + String.fromCharCode(65 + (data.amendments.length % 26))
                : '',
            originalContractNumber: data.originalContractNumber || '',
            amendmentTypeOtherFlag: data.amendmentTypeOtherFlag,
            amendmentReason: data.amendmentReason,
            contractNumberFinancialSystem: data.contractNumberFinancialSystem,
          },
          validity: {
            effectiveFromDate: data.effectiveFromDate,
            effectiveToDate: data.effectiveToDate,
            orig_EffecteFromDate: data.orig_EffecteFromDate,
            orig_EffectiveToDate: data.orig_EffectiveToDate,
            fiscalYearDescription: data.fiscalYearDescription,
          },
          purchaseOrderNumbers: data.purchaseOrderNumbers || [],
          isSignedFlag: data.isSignedFlag,
          isPrinted: data.isPrinted,
          id: data.id,
          services: [],
          isAmendment: data.amendmentFlag === '1',
        };

        this.isReadOnly = data.amendmentFlag == '1' && data.isSignedFlag;
        this.enableSignButton = data.amendmentFlag == '1' && !data.isSignedFlag;

        if (data.amendmentFlag == '0') {
          this.enableSaveButton = true;
        } else {
          this.enableSaveButton = !data.isSignedFlag;
        }

        const _addedOrderNumbers = data.purchaseOrderNumbers.map(
          (x) => x.fullNumber
        );

        await _getPurchaseOrderList().then((res) => {
          this.reactive.purchaseOrderList = res.data.filter((x) => {
            return !_addedOrderNumbers.includes(x.name);
          });
        });

        this.isLoaded = true;
      });
    },
    async signContract() {
      const amendmentDocument = await this.$refs.amendmentDocument;
      if (amendmentDocument.documents.length === 0) {
        amendmentDocument.isAdding = true;
        await nextTick();
        const valid = await amendmentDocument.validate();
        if (!valid) {
          this.ShowToast(
            'Error',
            'Es necesario añadir documento de Enmienda de Contrato antes de firmar.',
            'error'
          );
          return;
        }
      }
      this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea firmar la enmienda?',
        'Sí',
        'No'
      ).then((answer) => {
        if (answer) {
          _signContract(this.model.id)
            .then(() => {
              this.ShowToast(
                'Proceso Exitoso',
                'La enmienda fue firmada exitosamente',
                'success'
              );
              this.model.isSignedFlag = true;
              this.isReadOnly = true;
              this.enableSignButton = false;
              this.enableSaveButton = false;
            })
            .catch((error) => {
              this.ShowToast('Error', error.response.data.message, 'error');
            });
        }
      });
    },
    async UpdateAmendment() {
      const isValid = await this.$refs.formValidator.validate();
      this.reactive.isFormDirty = true;

      const { information, validity } = this.model;
      let isValidSeparation = true;

      const requiresBalanceValidation =
        information.amendmentTypeBalanceFlag == '1';

      const hasSeparationFunds = this.$refs.FundSeparation.separationFunds.some(
        (x) => x.contractId === this.contractId
      );

      // Validación de separación de fondos
      if (requiresBalanceValidation && !hasSeparationFunds) {
        const separationRef = this.$refs.FundSeparation.$refs.separationOfFunds;

        if (!separationRef) {
          this.ShowToast(
            'Alerta',
            'Favor añadir una separación de fondo.',
            'error'
          );
          return;
        }

        isValidSeparation = await separationRef.validate();
      }

      // Validaciones generales
      if (!isValid || !isValidSeparation) {
        this.ShowToast('', 'Información Incompleta', 'error');
        return;
      }

      if (
        requiresBalanceValidation &&
        !hasSeparationFunds &&
        this.$refs.FundSeparation?.accountNumbersSelected?.length === 0
      ) {
        this.ShowToast('Alerta', 'Favor añadir cifra de cuenta.', 'error');
        return;
      }

      if (
        !information.amendmentTypeBalanceFlag &&
        !information.amendmentTypeDateFlag &&
        !information.amendmentTypeOtherFlag
      ) {
        this.ShowToast(
          '',
          'Favor seleccionar vigencia, monto u otro a enmendar.',
          'error'
        );
        return;
      }

      if (validity.effectiveFromDate > validity.effectiveToDate) {
        this.ShowToast(
          '',
          'La fecha desde no puede ser mayor a la fecha hasta.',
          'error'
        );
        return;
      }

      // Construcción del payload
      const data = {
        contractId: this.contractId,
        amendmentTypeDateFlag: information.amendmentTypeDateFlag,
        amendmentTypeBalanceFlag: information.amendmentTypeBalanceFlag,
        amendmentTypeOtherFlag: information.amendmentTypeOtherFlag,
        effectiveFromDate: validity.effectiveFromDate,
        effectiveToDate: validity.effectiveToDate,
        amendmentReason: information.amendmentTypeOtherFlag
          ? information.amendmentReason
          : null,
      };

      // Llamada al servicio
      try {
        await _updateContractAmendment(data);
        this.enableSignButton = false;

        if (requiresBalanceValidation) {
          this.$refs.FundSeparation.saveHandler(true);
        }

        this.ShowToast(
          'Proceso Exitoso',
          'La enmienda ha sido actualizada exitosamente.',
          'success'
        );
      } catch (err) {
        const errorMsg = err.response?.data?.message || 'error';
        this.ShowToast('Alerta', errorMsg, 'error');
      }
    },

    async save() {
      const isValid = await this.$refs.formValidator.validate();
      this.reactive.isFormDirty = true;
      let { information, purchaseOrderNumbers, validity } = this.model;

      let isValidSeparation = true;

      if (information.amendmentTypeBalanceFlag == '1') {
        if (!this.$refs.FundSeparation.$refs.separationOfFunds) {
          this.ShowToast(
            'Alerta',
            'Favor añadir una separación de fondo.',
            'error'
          );
          return;
        }

        isValidSeparation = await this.$refs.FundSeparation.$refs.separationOfFunds.validate();
      }

      if (!isValid || !isValidSeparation) {
        this.ShowToast('', 'Información Incompleta', 'error');
        return;
      }

      if (
        information.amendmentTypeBalanceFlag == '1' &&
        this.$refs.FundSeparation?.accountNumbersSelected?.length === 0
      ) {
        this.ShowToast('Alerta', 'Favor añadir cifra de cuenta.', 'error');
        return;
      }

      if (
        !information.amendmentTypeBalanceFlag &&
        !information.amendmentTypeDateFlag &&
        !information.amendmentTypeOtherFlag
      ) {
        this.ShowToast(
          '',
          'Favor seleccionar vigencia, monto u otro a enmendar. ',
          'error'
        );
        return;
      }

      if (validity.effectiveFromDate > validity.effectiveToDate) {
        this.ShowToast(
          '',
          'La fecha desde no puede ser mayor a la fecha hasta.',
          'error'
        );
        return;
      }

      let validityData = information.amendmentTypeDateFlag ? validity : {};

      let data = {
        ...validityData,
        fiscalYearId: Number(this.params.fiscalYearId),
        companyId: Number(this.params.companyId),
        companyContractId: this.contractId,
        contractNumber:
          information.contractNumberBase + information.contractNumberAdded,
        purchaseOrderNumbers: information.amendmentTypeBalanceFlag
          ? purchaseOrderNumbers
          : null,
        amendmentTypeDateFlag: information.amendmentTypeDateFlag,
        amendmentTypeBalanceFlag: information.amendmentTypeBalanceFlag,
        amendmentAmt: this.subTotal.added,
        amendmentTypeOtherFlag: information.amendmentTypeOtherFlag,
        amendmentReason: information.amendmentTypeOtherFlag
          ? information.amendmentReason
          : null,
        contractNumberFinancialSystem:
          information.contractNumberFinancialSystem,
      };

      _insertContractAmendment(data)
        .then((response) => {
          this.isReadOnly = false;
          this.model.id = response.data;
          this.model.amendmentFlag = true;

          this.$router.push({
            name: 'provider-amendment',
            params: {
              companyId: this.params.companyId,
              fiscalYearId: this.params.fiscalYearId,
              contractId: this.model.id,
            },
          });

          this.$refs.FundSeparation.saveHandler(true);

          this.ShowToast(
            'Proceso Exitoso',
            'La enmienda ha sido guardada exitosamente.',
            'success'
          );
        })
        .catch((err) => {
          if (err.response != null)
            this.ShowToast(
              'Alerta',
              err.response.data.message || 'error',
              'error'
            );
        });
    },
    async onServiceSaving(savedService) {
      // If there is no contract we dont do operation on the server
      if (this.model.id == null) return true;

      let promise = null;

      savedService.cost =
        savedService.cost != null ? parseFloat(savedService.cost) : null;

      if (savedService.id == null)
        promise = _createContractService(this.model.id, {
          disciplineTypeId: savedService.disciplineTypeId,
          locationTypeId: savedService.locationTypeId,
          serviceModalityTypeId: savedService.serviceModalityTypeId,
          serviceTypeId: savedService.serviceTypeId,
          therapyDurationId: savedService.therapyDurationId,
          cost: savedService.cost,
        });
      else
        promise = _editContractService({
          id: savedService.id,
          disciplineTypeId: savedService.disciplineTypeId,
          locationTypeId: savedService.locationTypeId,
          serviceModalityTypeId: savedService.serviceModalityTypeId,
          serviceTypeId: savedService.serviceTypeId,
          therapyDurationId: savedService.therapyDurationId,
          cost: savedService.cost,
        });

      let result = false;

      await promise
        .then((response) => {
          this.ShowToast(
            'Proceso Exitoso',
            'Servicio guardado exitosamente.',
            'success'
          );

          savedService.id = response.data.id;

          result = true;
        })
        .catch((error) => {
          this.ShowToast('Error', error.response.data.message, 'error');
          result = false;
        });

      return result;
    },
    async onServiceDeleting(serviceId) {
      // If there is no contract we dont do operation on the server
      if (this.model.id == null) return true;

      let promise = null;

      promise = _deleteContractService(serviceId);

      let result = false;

      await promise
        .then(() => {
          this.ShowToast(
            'Proceso Exitoso',
            'Servicio eliminado exitosamente.',
            'success'
          );
          result = true;
        })
        .catch((error) => {
          this.ShowToast('Error', error.response.data.message, 'error');
          result = false;
        });

      return result;
    },
    async getAcademicYears() {
      const { data } = await _getAcademicYear(this.params.fiscalYearId);
      this.academicYears = data?.description;
    },
    async downloadDocument(document) {
      const params = {
        proposalRequestId: this.proposalRequestId,
        date: document.date,
        type: document.type,
      };
      await getContractDocument(params).then((response) => {
        _generalApi.ConvertToBlob(response.data);
      });
    },
  },
};
</script>
<style lang="scss">
@import '@/shared/scss/config/_colors.scss';
.custom-nav-container {
  border-bottom: 1px solid map-get($colors, 'gray-5');
  margin-left: 20px;
  margin-right: 20px;
  .nav-item {
    .nav-link {
      font-size: 14px;
      padding-right: 100px;
      color: map-get($colors, 'gray-6');
      padding-left: 100px;
      &.active {
        border-bottom: 3px solid map-get($colors, 'orange');
        color: map-get($colors, 'orange');
        font-weight: bold;
      }
      &.active:after {
        content: unset;
      }
    }
  }
}

.document__container {
  background-color: #f6f6f6;
}

.document-signed__container {
  display: flex;
  justify-content: end;
  padding-right: 27px;
}

.document-info {
  --bg-color: map-get($colors, 'secondary-3');
  background-color: var(--bg-color);
  padding: 10px 30px;

  &__description {
    display: flex;
    align-items: center;

    .content {
      margin-top: 10px;
    }
    .title {
      color: map-get($colors, 'secondary-6');
      font-size: 0.875rem;
    }
    .file-icon {
      color: map-get($colors, 'orange');
      margin-right: 0.9rem !important;
    }
    @media only screen and (max-width: 768px) {
      .title,
      .content {
        font-size: 0.8572rem;
      }
    }

    ::v-deep &__actions {
      margin-left: 0px;
      .show-icon i {
        margin-right: 0px !important;
      }

      .font-weight-normal {
        label {
          display: none;
        }
      }

      .upload-document {
        .file-select {
          cursor: pointer;
          span {
            font-size: 1rem;
            @media screen and (max-width: 768px) {
              font-size: 0.7857rem;
            }
          }
          em {
            @media screen and (max-width: 768px) {
              padding: 0.4286rem !important;
            }
          }
        }
      }

      .custom-upload-document {
        .file-input-container {
          background-color: map-get($colors, 'green');
          border: 1px solid map-get($colors, 'green');

          .file-select {
            cursor: pointer;
            span {
              display: none;
            }
            em {
              padding: 0px !important;
              color: map-get($colors, 'white');
            }
          }
        }
      }
    }
  }
}
</style>
